import * as ActionTypes from './actionType.js';


const reducerMap = {

    [ActionTypes.SET_QUESTION_EXPLAIN_CURRENT]: (state, payload) => {//设置任务阶段选中状态
        return Object.assign({}, state, {
            current: payload
        });
    },
}
export const INITIALIZE_STATE = {
    list:[],
    current:'pre_assign',
}
export default (state = INITIALIZE_STATE, action = {}) => {
    const { type, payload } = action;
    const reducer = reducerMap[type];
    if (reducer) {
        return reducer(state, payload);
    } else {
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_explain/reducer.js